/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
import React, { Component } from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import {
  Grid,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  TextField,
  Stack,
  Checkbox,
  FormControlLabel,
  styled,
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
} from '@mui/material';

import { COLOR } from '../../helpers/colors';

const Accordion = styled(props => <MuiAccordion disableGutters elevation={0} square {...props} />)(
  () => ({
    '&:not(:last-child)': {
      borderRight: 0,
      borderLeft: 0,
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  })
);

const AccordionSummary = styled(props => (
  <MuiAccordionSummary
    expandIcon={
      <MenuIcon
        fontSize="large"
        sx={{
          transform: props.dir === 'rtl' ? 'rotate(180deg)' : 'none',
          mt: 1,
          display: { xs: 'block', md: 'none' },
        }}
      />
    }
    {...props}
  />
))(() => () => ({
  padding: 0,
  flexDirection: 'row',
  justifyContent: 'space-between',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(0deg)',
  },
  '& .-MuiButtonBase-root-MuiAccordionSummary-root': {
    padding: 0,
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
}));
const accordionProps = {
  sx: {
    pointerEvents: 'none',
  },
  expandIcon: (
    <MenuIcon
      sx={{
        pointerEvents: 'auto',
        ml: 1.25,
        display: { xs: 'block', md: 'none' },
      }}
      fontSize="large"
    />
  ),
};
const label = 'Without label';
class Filter extends Component {
  constructor(props) {
    super(props);
    this.initialState = {};
    this.props.filterConfig.forEach(item => {
      if (item.type === 'Range') {
        this.initialState = {
          ...this.initialState,
          [`${item.id}from`]: '',
          [`${item.id}to`]: '',
        };
      } else {
        this.initialState = {
          ...this.initialState,
          [item.id]: '',
        };
      }
    });
    this.state = this.initialState;
  }

  async componentDidMount() {
    try {
      this.props.filterConfig.forEach(item => {
        if (item.type === 'Checkbox' && item.isMultiSelect) {
          item.onChange = this.onChipCheck;
        } else if (item.type === 'Range') {
          item.onFromChange = value => {
            this.setState({ [`${item.id}from`]: value }, () => this.onSave());
          };
          item.onToChange = value => {
            this.setState({ [`${item.id}to`]: value }, () => this.onSave());
          };
        } else {
          item.onChange = value => {
            this.setState({ [item.id]: value }, () => this.onSave());
          };
        }
      });
    } catch (err) {
      console.log(err, 'errror');
    }
  }

  onChipCheck = (id, item) => {
    try {
      const data = item.config.data.map(c => {
        const d = c;

        if (d.id === id) {
          d.checked = !d.checked;
        }
        return d;
      });
      item = {
        ...item,
        config: {
          data,
        },
      };
      this.onSave();
    } catch (err) {
      console.log(err);
    }
  };

  onSave = () => {
    try {
      const filters = [];
      this.props.filterConfig.forEach(item => {
        const itemName = item.id;
        if (item.type === 'Checkbox' && item.isMultiSelect) {
          const values = [];
          item.config.data.forEach(i => {
            if (i.checked) {
              values.push(i.value);
            }
          });
          if (values.length > 0) {
            filters.push({ key: item.dataKey, value: values, type: 'Checkbox' });
          }
        } else if (item.type === 'Select' && this.state[itemName] !== '') {
          filters.push({ key: item.dataKey, value: this.state[itemName], type: 'Select' });
        } else if (item.type === 'TextField' && this.state[itemName] !== '') {
          filters.push({ key: item.dataKey, value: this.state[itemName], type: 'TextField' });
        } else if (
          item.type === 'Range' &&
          this.state[`${itemName}from`] !== '' &&
          this.state[`${itemName}to`] !== ''
        ) {
          const value = { from: this.state[`${itemName}from`], to: this.state[`${itemName}to`] };
          filters.push({ key: item.dataKey, value, type: 'Range' });
        }
      });
      this.props.saveFilter(filters);
    } catch (err) {
      console.log(err);
    }
  };

  onReset = () => {
    try {
      this.props.filterConfig.forEach(item => {
        if (item.type === 'Checkbox') {
          const dConfig = item.config.data.map(c => {
            const d = c;
            return { ...d, checked: false };
          });
          this.setState({
            [item.id]: { data: dConfig },
          });
          item.config.data = dConfig;
        } else if (item.type === 'Range') {
          this.setState({
            [`${item.id}from`]: '',
            [`${item.id}to`]: '',
          });
        } else {
          this.setState({ [item.id]: '' });
        }
      });
      this.props.clearFilter();
    } catch (err) {
      console.log(err);
    }
  };

  returnOptions = item => {
    return item.config.data.map((i, dIndex) => (
      <MenuItem
        key={dIndex.toString()}
        value={i.value}
        sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
      >
        {i.label}
      </MenuItem>
    ));
  };

  filterItems = () => {
    const { t, isProductsLoading } = this.props;
    return this.props.filterConfig.map((item, index) => {
      switch (item.type) {
        case 'Select':
          return (
            <Stack key={index.toString()} sx={{ mt: 3, mb: 2 }}>
              <Typography variant="subtitle1" sx={{ fontSize: { xs: 14, sm: 16, md: 16 }, mb: 1 }}>
                {item.label}
              </Typography>

              <FormControl fullWidth>
                <Select
                  // size="small"
                  displayEmpty
                  fullWidth
                  value={this.state[item.id]}
                  onChange={e => {
                    const val = e.target.value;
                    item.onChange(val);
                  }}
                  sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
                  inputProps={{ 'aria-label': label }}
                >
                  <MenuItem disabled value="">
                    {t('libraryScreenTranslations:SELECT')}
                  </MenuItem>
                  {this.returnOptions(item)}
                </Select>
              </FormControl>
            </Stack>
          );
        case 'Checkbox':
          return (
            <Stack key={item.id}>
              <Typography variant="subtitle1" sx={{ fontSize: { xs: 14, sm: 16, md: 16 } }}>
                {item.label}
              </Typography>
              <Stack sx={{ overflowY: 'auto', pl: 1 }}>
                {item.config.data &&
                  item.config.data.map((d, dIndex) => (
                    <FormControlLabel
                      key={dIndex.toString()}
                      control={
                        <Checkbox
                          key={d.id}
                          checked={d.checked}
                          disabled={isProductsLoading}
                          onChange={() => {
                            item.onChange(d.id, item);
                          }}
                        />
                      }
                      label={
                        <Typography sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}>
                          {d.label}
                        </Typography>
                      }
                      sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
                    />
                  ))}
              </Stack>
            </Stack>
          );
        case 'TextField':
          return (
            <Stack key={item.id} sx={{ mt: 3, mb: 2 }}>
              <Typography variant="subtitle1" sx={{ fontSize: { xs: 14, sm: 16, md: 16 }, mb: 1 }}>
                {item.label}
              </Typography>
              <TextField
                fullWidth
                name="material"
                value={this.state[item.id]}
                onChange={e => item.onChange(e.target.value)}
              />
            </Stack>
          );
        case 'Range':
          return (
            <Stack key={item.id} sx={{ mt: 3, mb: 2 }} spacing={1}>
              <Typography variant="subtitle1" sx={{ fontSize: { xs: 14, sm: 16, md: 16 } }}>
                {item.label}
              </Typography>

              <FormControl fullWidth>
                <Select
                  // size="small"
                  displayEmpty
                  fullWidth
                  value={this.state[`${item.id}from`]}
                  onChange={e => {
                    const val = e.target.value;
                    item.onFromChange(val);
                  }}
                  sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
                  inputProps={{ 'aria-label': label }}
                >
                  <MenuItem disabled value="">
                    {t('libraryScreenTranslations:FROM')}
                  </MenuItem>
                  {this.returnOptions(item)}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <Select
                  // size="small"
                  displayEmpty
                  fullWidth
                  value={this.state[`${item.id}to`]}
                  onChange={e => {
                    const val = e.target.value;
                    item.onToChange(val);
                  }}
                  sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
                  inputProps={{ 'aria-label': label }}
                >
                  <MenuItem disabled value="">
                    {t('libraryScreenTranslations:TO')}
                  </MenuItem>
                  {this.returnOptions(item)}
                </Select>
              </FormControl>
            </Stack>
          );
        default:
          return <></>;
      }
    });
  };

  renderSummaryContent = () => (
    <Stack
      sx={{ flex: 1, mb: { md: 2 } }}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography variant="h5" textAlign="center">
        {this.props.t('libraryScreenTranslations:FILTERS')}
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        onClick={e => {
          e.stopPropagation();
          this.onReset();
        }}
        disabled={this.props.isProductsLoading || this.props.disableClear}
        sx={{ pointerEvents: 'auto', fontSize: { xs: 12, sm: 12, md: 14 } }}
      >
        {this.props.t('libraryScreenTranslations:CLEAR')}
      </Button>
    </Stack>
  );

  returnMobileView = () => {
    return (
      <Accordion>
        <AccordionSummary {...accordionProps}>{this.renderSummaryContent()}</AccordionSummary>
        <MuiAccordionDetails sx={{ pointerEvents: 'auto' }}>
          {this.filterItems()}
        </MuiAccordionDetails>
      </Accordion>
    );
  };

  returnWebView = () => (
    <>
      {this.renderSummaryContent()}
      {this.filterItems()}
    </>
  );

  render() {
    return (
      <Grid
        xs={12}
        sm={12}
        md={3}
        item
        sx={{ p: 2, background: COLOR.whiteTextColor, boxShadow: '0 1px 8px 0 rgb(0 0 0 / 6%)' }}
        mb={5}
      >
        <Grid item sx={{ display: { xs: 'block', md: 'none' } }}>
          {this.returnMobileView()}
        </Grid>

        <Grid item sx={{ display: { xs: 'none', md: 'block' } }}>
          {this.returnWebView()}
        </Grid>
      </Grid>
    );
  }
}

export default Filter;
